import { call, put, takeLatest, delay } from 'redux-saga/effects';

import {
	createCoupon,
	createCouponSuccess,
	createCouponFailure,
	getCoupons,
	getCouponsFailure,
	getCouponsSuccess,
	removeCoupon,
	removeCouponFailure,
	removeCouponSuccess,
	updateCoupon,
	updateCouponFailure,
	updateCouponSuccess,
	getCouponById,
	getCouponByIdFailure,
	getCouponByIdSuccess,
	getCouponByCode,
	getCouponByCodeFailure,
	getCouponByCodeSuccess,
} from '.';

import couponService from 'src/services/CouponService';

function* rootSaga() {
	yield takeLatest(createCoupon, createCouponSaga);
	yield takeLatest(getCoupons, getCouponsSaga);
	yield takeLatest(removeCoupon, removeCouponSaga);
	yield takeLatest(updateCoupon, updateCouponSaga);
	yield takeLatest(getCouponById, getCouponByIdSaga);
	yield takeLatest(getCouponByCode, getCouponByCodeSaga);
}

function* createCouponSaga({ payload }) {
	try {
		yield delay(300);
		const createdCompany = yield call(couponService.create, payload);
		yield put(createCouponSuccess(createdCompany));
	} catch (error) {
		yield put(createCouponFailure(error));
	}
}

function* getCouponsSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(couponService.getAllCoupons, payload);
		yield put(getCouponsSuccess(response));
	} catch (error) {
		yield put(getCouponsFailure(error));
	}
}

function* getCouponByIdSaga({ payload }) {
	const clientId = payload;
	try {
		yield delay(300);
		const response = yield call(couponService.getById, clientId);
		yield put(getCouponByIdSuccess(response));
	} catch (error) {
		yield put(getCouponByIdFailure(error));
	}
}

function* getCouponByCodeSaga({ payload }) {
	const code = payload;
	try {
		yield delay(300);
		const response = yield call(couponService.getByCode, code);
		yield put(getCouponByCodeSuccess(response));
	} catch (error) {
		yield put(getCouponByCodeFailure(error));
	}
}

function* removeCouponSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const response = yield call(couponService.remove, id);
		yield put(removeCouponSuccess(response));
	} catch (error) {
		yield put(removeCouponFailure(error));
	}
}

function* updateCouponSaga({ payload }) {
	const { couponId: id, data: couponForm } = payload;
	try {
		yield delay(300);
		const response = yield call(couponService.update, id, couponForm);
		yield put(updateCouponSuccess(response));
	} catch (error) {
		yield put(updateCouponFailure(error));
	}
}

export default rootSaga;
